import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";
import { storeBudgetDashboardServices } from "data/storeBudgetData";
import { ArrowBackRounded } from "@mui/icons-material";
import ListStoreBudget from "./ListStoreBudget/ListStoreBudget";
import CreateStoreBudget from "./createStoreBudget/CreateStoreBudget";
import StoreBudgetReport from "./StoreBudgetReport/StoreBudgetReport";

export default function StoreBudgetTracker() {
  const navigate = useNavigate();
  const [currentPath, service] = useOutletContext();

  const tabComponents = {
      [storeBudgetDashboardServices.masters.types.report.key]: StoreBudgetReport,
      [storeBudgetDashboardServices.masters.types.store_budget.key]: ListStoreBudget,
      [storeBudgetDashboardServices.masters.types.create_store_budget.key]: CreateStoreBudget,
    };
  const ActiveTab = tabComponents[currentPath];

  return (
    <Box width="100%" p={1} sx={{ maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
          <Box display="flex" alignItems="center" columnGap={1} mt={2}>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton>
            <Typography variant="h5">{service?.name}</Typography>
          </Box>
          {ActiveTab ? <ActiveTab /> : null}
    </Box>
  );
}
